import { render } from "./CurrentPrice.vue?vue&type=template&id=5020d190"
import script from "./CurrentPrice.vue?vue&type=script&lang=js"
export * from "./CurrentPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__